import { animate } from '../../core/animations';

export default () => {
  $(document).on('shopify:section:load', (e) => {
    const sectionId = e.detail.sectionId;
    if ($(`#shopify-section-${sectionId}`).length) {
      animate();
    }
  });
};
